import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Tile, fmtDate } from "./primitives";

export default function ListingsPanel({ listings }) {
  return (
    <Tile title={`Advisor listings (${listings.length})`} testid="tile-listings">
      {listings.length === 0 ? (
        <div className="text-xs text-[#5C6B62]">No active listings yet.</div>
      ) : (
        <div className="space-y-2 max-h-64 overflow-y-auto">
          {listings.map((l) => (
            <div key={l.website_url + l.expires_at} className="text-xs border-b border-[#F0EFEA] pb-2 last:border-0">
              <div className="font-medium text-[#1C2B23]">{l.display_name}</div>
              {l.tagline && <div className="text-[#5C6B62] mt-0.5">{l.tagline}</div>}
              <div className="flex items-center gap-2 mt-1 text-[#5C6B62]">
                <span>{l.location || "—"}</span>
                <span>·</span>
                <span>exp {fmtDate(l.expires_at)}</span>
                <a
                  href={l.website_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="ml-auto text-[#2B5339] hover:underline inline-flex items-center gap-0.5"
                >
                  visit <ArrowUpRight size={10} />
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </Tile>
  );
}
